import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TextInput,
  Button,
  Table,
  DataTable,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DataTableSkeleton,
} from 'carbon-components-react';

import { RadioButton20, RadioButtonChecked20 } from '@carbon/icons-react';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getError, entitiesLabels, apioperation } from '../../helpers/Constants';
import { api } from '../../helpers/api/api';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import AuditRepository from '../../helpers/api/AuditRepository';

export class FindGHRSEmployer extends Component {
  initState = () => {
    return {
      badgeNumber: '',
      surname: '',
      name: '',
      selectedRow: null,
      isLoading: false,
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      itemList: [],
    };
  };

  constructor(props) {
    super(props);
    this.state = {
      ...this.initState(),
      employees: null,
    };
    this.repository = new AuditRepository();
  }

  handleChangeModel = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    this.setState({ [inputName]: inputValue });
  };

  handleClickOk = () => {
    let employersList = this.state.itemList || [];
    let selectedId = this.state.selectedRow;
    let employer = employersList.find((el) => el.id === selectedId);
    let participantAlreadyAdded = false
    if(this.props.participants){
      participantAlreadyAdded = this.props.participants.find((el) => el.idEmployer === employer.id) ? true : false;
    } 

    if (selectedId == null || employer == null) {
      //todo messaggio toast
      showNotification.warning(`${entitiesLabels.WARNING}`,'Select an employer');
      return;
    }

    if(participantAlreadyAdded){
      showNotification.warning(`${entitiesLabels.WARNING}`,'Employer already present in the training');
      return;
    }

    return this.props.onOk(employer);
  };

  handleChangePaging = (event) => {
    this.getEmployees(event);
  };

  handleClearSearch = () => {
    this.setState({ ...this.initState() });
  };

  /*************API********************/
  getEmployeesFromApi = (param) => {
    this.setState({ isLoading: true });

    const data = {
      params: {
        page: param && param.page ? param.page : this.state.currentPage,
        pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
        badgeNumber: this.state.badgeNumber,
        surname: this.state.surname,
        name: this.state.name,
      },
    };
    //TODO validazione almeno 1 campo di ricerca valorizzato, e min length per name e surname ?
    api
      .getWithParam('/employees', data)
      .then((response) => {
        this.setState({
          ...response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.EMPLOYER, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  getEmployees = async (param) => {
    const badgeNumber = this.state.badgeNumber;
    const surname = this.state.surname;
    const name = this.state.name;

    if (badgeNumber || surname || name) {
      const isOnline =
        typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean'
          ? navigator.onLine
          : true;
      if (isOnline) return this.getEmployeesFromApi(param);

      try {
        this.setState({ isLoading: true });
        var employees = this.state.employees;
        if (!employees) {
          //se gli employees non sono ancora stati caricati nello state, li recupoero dalla cache
          employees = await this.repository.getCachedEmployees();
          if (!employees) {
            //se la cache è vuota recupero dal server
            employees = (await api.getAll(`/employees/all`)).data;
          }

          this.setState({
            employees,
          });
        }

        const filterItem = employees
          .filter(
            (el) =>
              (!badgeNumber || el.ghrS_ID === badgeNumber) &&
              (!surname || el.surname.toLowerCase().includes(surname.toLowerCase())) &&
              (!name || el.name.toLowerCase().includes(name.toLowerCase()))
          )
          .slice(0, 50); //restituisco solo una parte dei risultati

        this.setState({
          itemList: filterItem,
        });
      } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.EMPLOYER, apioperation.GET));
      } finally {
        this.setState({
          isLoading: false,
        });
      }
    } else {
      //inserire almeno un campo
      showNotification.warning(`${entitiesLabels.WARNING}`,'Fill the search fields');
    }
  };
  /*********************************/

  render() {
    const modalHeader = {
      title: 'Import employee from GHRS',
      iconDescription: 'Close',
      buttonOnClick: () => this.props.onCancel(2),
    };
    const DTHeaders = [
      { key: 'ghrS_ID', header: 'Badge Number' },
      { key: 'company_ID', header: 'Company' },
      { key: 'surname', header: 'Surname' },
      { key: 'name', header: 'Name' },
      { key: 'country', header: 'Nationality' },
    ];
    const DTRows = this.state.itemList || [];

    return (
      <ComposedModal
        className="light-modal"
        open={this.props.isOpenModal}
        danger="false"
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" {...modalHeader}></ModalHeader>
        <ModalBody className="margin-modal margin-modal-content ">
          <div className="bx--grid--full-width search-form">
            <div className="bx--row">
              <div className="bx--col-lg-4">
                <label>Badge number</label>
              </div>
              <div className="bx--col-lg-8">
                <TextInput
                  id="badgeNumber"
                  name="badgeNumber"
                  placeholder="Input badge number"
                  value={this.state.badgeNumber}
                  onChange={this.handleChangeModel}
                  type="text"
                  hideLabel={true}
                  labelText=""
                />
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-4">
                <label>Surname</label>
              </div>
              <div className="bx--col-lg-8">
                <TextInput
                  id="surname"
                  name="surname"
                  placeholder="Input surname"
                  value={this.state.surname}
                  onChange={this.handleChangeModel}
                  type="text"
                  hideLabel={true}
                  labelText=""
                />
              </div>
            </div>
            <div className="bx--row margin-modal-content">
              <div className="bx--col-lg-4">
                <label>Name</label>
              </div>
              <div className="bx--col-lg-8">
                <TextInput
                  id="name"
                  name="name"
                  placeholder="Input name"
                  value={this.state.name}
                  onChange={this.handleChangeModel}
                  type="text"
                  hideLabel={true}
                  labelText=""
                />
              </div>
            </div>

            <div className="searchFormFooter">
              <Button
                className="button--max-width"
                size="small"
                kind="secondary"
                onClick={() => this.handleClearSearch()}
              >
                Clear
              </Button>
              <Button
                className="button--max-width"
                size="small"
                kind="primary"
                onClick={() => this.getEmployees()}
              >
                Search
              </Button>
            </div>
          </div>
          <div className="bx--grid">
            <div className="bx--row">
              <DataTable
                rows={DTRows}
                headers={DTHeaders}
                useZebraStyles={true}
                size="compact"
                radio
                render={({ rows, headers, getHeaderProps, getRowProps }) => (
                  <TableContainer className="max-width">
                    {this.state.isLoading ? (
                      <DataTableSkeleton headers={[]} rowCount={3} zebra={false} compact={false} />
                    ) : (
                      <Table className="">
                        <TableHead className="colorgray">
                          <TableRow>
                            <th scope="col" />
                            {headers.map((header) => (
                              <TableHeader {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length == 0 ? (
                            <NoRecordsPlaceholder
                              labelText="No records"
                              colSpan={headers.length + 1}
                            />
                          ) : (
                            rows.map((row) => (
                              <TableRow
                                {...getRowProps({ row })}
                                onClick={() => this.setState({ selectedRow: row.id })}
                              >
                                <td>
                                  {this.state.selectedRow === row.id ? (
                                    <RadioButtonChecked20 fill="#1A3E4C" aria-label="" />
                                  ) : (
                                    <RadioButton20 fill="#1A3E4C" aria-label="" />
                                  )}
                                </td>
                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                )}
              />
            </div>
            {/*<div className="footer-pagination">
                            <Pagination {...paginationProps()} />
                        </div> */}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.props.onCancel(2)}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.handleClickOk()}>
            Ok
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}

FindGHRSEmployer.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  isOpenModal: PropTypes.bool,
};
